import userInfoStore from "@/store/user.store";
import appStore from "@/store/app.store";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Popover from "@/component/Popover";
import { openUpgrateWindow, openAboutWindow, openFeedbackWindow, getClientVersion } from "@/utils/window";
import MenuIcon from "@/assets/common/ic_userMenu.svg?react";
// import WordIcon from "@/assets/common/ic_word.svg?react";
import { RuningInLink } from "@/constants";
import useCheckEditBeforeClick from "../Summary/useCheckEditBeforeClick";
import UserInfo from "./UserInfo";
import UserAvatar from "./UserAvatar";
import useGetDisplayUserInfo from "./useGetDisplayUserInfo";
import AccountManager from "./AccountManage";
import { IS_PRIVATE } from '@/config';

interface IOptions {
  id: string;
  label: React.ReactNode;
}

const User = () => {
  const [showSelect, setShowSelect] = useState(false);
  const [version, setVersion] = useState("");

  const [showAccount, setShowAccount] = useState(false);

  const hasUpdate = appStore((state) => state.hasUpdate);

  const navigate = useNavigate();

  const userInfo = userInfoStore();

  const { displayUserInfo } = useGetDisplayUserInfo();

  const categoryList: IOptions[] = useMemo(() => {
    const account = {
      id: "ACCOUNT",
      label: (
        <div className="flex items-center h-5.5">
          账号管理
        </div>
      ),
      disabled: false,
    };

    const about = {
      id: "ABOUT",
      label: (
        <div className="flex items-center justify-between h-5.5">
          <div className="whitespace-nowrap flex items-center">
            <div>关于AI会记</div>
          </div>
          {hasUpdate && <div className="w-11.5 h-5 lh-5 text-align-center text-10px text-mx-primary bg-#4981F21A/10 rounded-25">新版本</div>}
        </div>
      ),
      disabled: !version,
    };

    const feedback = {
      id: "FEEDBACK",
      label: (
        <div className="flex items-center h-5.5">
          反馈
        </div>
      ),
      disabled: IS_PRIVATE || !RuningInLink,
    };

    // 暂时隐藏热词管理
    // const hotWord = {
    //   id: "HOTWORD",
    //   label: (
    //     <div className="flex items-center h-7">
    //       <WordIcon className="mr-2 size-4" />
    //       热词管理
    //     </div>
    //   ),
    // };

    // const pathname = location.pathname;
    const list = [feedback, about, account].filter(item => !item.disabled);

    return list as IOptions[];
  }, [version, hasUpdate]);

  const handleChoose = (value: IOptions) => {
    if (value.id === "ACCOUNT") {
      openAccountMenu();
    } else if (value.id === "ABOUT") {
      if (hasUpdate) {
        openUpgrateWindow();
      } else {
        openAboutWindow();
      }
    } else if (value.id === "FEEDBACK") {
      openFeedbackWindow({
        mobile: userInfo.mobile,
        userId: userInfo.userId,
      });
    } else if (value.id === "HOTWORD") {
      navigateToPage("/hotWord");
    }
  };

  const navigateToPage = useCheckEditBeforeClick((path: string) => {
    navigate(path);
  });

  const openAccountMenu = () => {
    setShowAccount(true);
  }

  useEffect(() => {
    getClientVersion().then((res) => {
      setVersion(res);
    });
  }, []);

  return (
    <div className="flex items-center relative no_drag">
      {showAccount && <AccountManager onClose={() => { setShowAccount(false); }}></AccountManager>}
      {
        <Popover
          placement="bottomRight"
          visible={showSelect}
          setVisible={setShowSelect}
          content={
            <div className="w-66">
              <UserInfo userInfo={displayUserInfo} />
              {categoryList.map((item) => {
                return (
                  <div
                    key={item.id}
                    className="mt-1 w-auto min-w-32.5 whitespace-nowrap px-4 py-2.25 text-size-3.5 color-#191D26 hover:bg-#191D260D rd-1.5 flex flex-items-center flex-justify-between cursor-pointer"
                    onClick={() => {
                      handleChoose(item);
                      setShowSelect(false);
                    }}
                  >
                    <span className="flex-1 mr-2">{item.label}</span>
                    <MenuIcon />
                  </div>
                );
              })}
            </div>
          }
        >
          <div className="h-7 w-7 rounded-full no_drag relative" >
            <UserAvatar userInfo={displayUserInfo} className="w-7 h-7 text-10.5px font-600" />
          </div>
        </Popover>
      }
    </div>
  );
};

export default User;
